import { ObjectList } from "web/components"

import {
  useAddDealComparableDeals,
  useFindComparableDealsView,
} from "web/hooks/data"

import { useCurrentTLO } from "web/hooks/context"
import { NavigationProvider } from "web/contexts"

import FindComparablesActions from "../shared/FindComparablesActions"

export default function FindComparableDeals({ baseUrl }) {
  const { userCan, data: deal } = useCurrentTLO()
  const userCanAddComparables = userCan("update")

  const [view] = useFindComparableDealsView({ deal })

  const addComparables = useAddDealComparableDeals({ deal })

  const backToComparablesUrl = baseUrl.split("/find")[0]

  function goToComparableDeal(sale) {
    window.Turbo.visit(`/markets/global/sales/view/${sale.id}`)
  }

  return (
    <NavigationProvider viewGroup={{}} viewId={view.id}>
      <div className="-mx-3 flex min-h-0 grow flex-col lg:-mx-5">
        <ObjectList
          subjectType="sale"
          parentSubjectId={deal.id}
          parentSubjectType="deal"
          fetchURL={`/deals/${deal.id}/sales/available_deals`}
          availableViews={["table", "map", "compare"]}
          defaultView="table"
          listType="deal_find_comparable_deals"
          enableExport={false}
          onItemClick={goToComparableDeal}
          enableLocationIndex
          customListActions={
            <FindComparablesActions
              userCanAddComparables={userCanAddComparables}
              addComparables={addComparables}
              backUrl={backToComparablesUrl}
            />
          }
          rootUrl={baseUrl}
          canRedirectToRootUrl={false}
          breadcrumbs={[
            { name: "Comparables", href: backToComparablesUrl },
            { name: "Find Comparables", href: null },
          ]}
        />
      </div>
    </NavigationProvider>
  )
}
